import { createAction } from "redux-actions";

import { CLUSTER, SEGMENTS, SELECTED_COUNTRIES } from "./types";

const setCluster = createAction(CLUSTER);
const setSegments = createAction(SEGMENTS);
const setSelectedCountries = createAction(SELECTED_COUNTRIES);

export const selectCluster = (cluster) => async (dispatch) => {
  dispatch(setCluster(cluster));
};

export const selectSegments = (segments) => async (dispatch) => {
  dispatch(setSegments(segments));
};

export const selectCountries = (selectedCountries) => async (dispatch) => {
  dispatch(setSelectedCountries(selectedCountries));
};
